import React from 'react'; // eslint-disable-line
import universal from '@core-ui/universal';
import { AppStateProvider } from '@core-ui/app-state-provider';
import { SitewideContextProvider } from '@mfe/sitewide';
import { BreakpointProvider } from '@core-ui/breakpoint-provider';
import { I18nProvider } from '@core-ui/i18n';
import BrandInfoProvider from '@core-ui/brand-info-provider';
import { CertonaProvider } from '@core-ui/certona-provider';
import { LocalizationProvider } from '@core-ui/localization-provider';
import MarketingComponent from '@core-ui/marketing-ui';
import { MarketingProvider } from '@core-ui/marketing-provider';
import { PersonalizationProvider } from '@core-ui/personalization-provider';
import { StitchStyleProvider } from '@core-ui/react-stitch';
import { Provider as FeatureFlagProvider } from '@core-ui/feature-flags';

import CategoryPage from './components/category-page';
import With3rdParties from './with3rdParties';
import { ABSegmentContextProvider } from './components/ab-segment-context/ABSegmentContext';
import { AppProps } from './App';

// this is a carryover from the catagory-page-old repo, delete if not useful
const Style = universal(
  ({ abbrBrand }: { abbrBrand: string }) =>
    import(`./style-entry/${`${abbrBrand}-category`}`),
  {
    loading: () => null,
  }
);

export const errorLogger = (props: any, error: any) => {
  props.errorLogger(error);

  throw error;
};

const App = (props: AppProps): JSX.Element => {
  const { abbrBrand, enabledFeatures, locale, translations } = props;

  return (
    <AppStateProvider value={{ ...props, brandName: abbrBrand }}>
      <SitewideContextProvider>
        <FeatureFlagProvider
          value={{
            enabledFeatures,
            featureVariables: props.featureVariables,
          }}
        >
          <ABSegmentContextProvider value={props.abSeg}>
            <BreakpointProvider
              initialMedia={props.initialMedia}
              initialSizeClass={props.initialSizeClass || 'Mobile'}
            >
              <I18nProvider locale={locale} translations={translations}>
                <LocalizationProvider
                  locale={locale}
                  translations={translations}
                >
                  <PersonalizationProvider
                    datalayer={props.datalayer}
                    errorLogger={(err: any) => errorLogger(props, err)}
                    marketAgnosticBrandCode={props.marketAgnosticBrandCode}
                  >
                    <BrandInfoProvider {...props}>
                      <StitchStyleProvider
                        brand={props.brand}
                        enabledFeatures={enabledFeatures}
                      >
                        <Style abbrBrand={abbrBrand} />
                        <With3rdParties {...props}>
                          <CertonaProvider
                            errorLogger={() => {}} // eslint-disable-line
                            pageType={props.pageType}
                          >
                            <MarketingProvider
                              {...props}
                              MarketingComponent={MarketingComponent}
                            >
                              <CategoryPage {...props} />
                            </MarketingProvider>
                          </CertonaProvider>
                        </With3rdParties>
                      </StitchStyleProvider>
                    </BrandInfoProvider>
                  </PersonalizationProvider>
                </LocalizationProvider>
              </I18nProvider>
            </BreakpointProvider>
          </ABSegmentContextProvider>
        </FeatureFlagProvider>
      </SitewideContextProvider>
    </AppStateProvider>
  );
};

export { App };
